import { z } from 'zod';

export const INSTALLATION_BYPASS_STEP = 'CUSTOMER_CONFIRMATION' as const;

export const installationBypassSchema = z.object({
  reason: z.string({ required_error: 'Motivo é obrigatório' })
    .trim()
    .min(1, 'Motivo é obrigatório')
    .max(500, 'Motivo deve ter no máximo 500 caracteres'),
  containers: z.boolean().default(false),
  solfacil_orders: z.boolean().default(false),
});

export type InstallationBypassForm = z.infer<typeof installationBypassSchema>;
